import { useState } from "react";
import { Card, Collapse, Row, Col, Modal, Button } from "react-bootstrap";
import {
  FiChevronDown,
  FiEdit,
  FiTrash2,
} from "react-icons/fi";
import EditInvoiceModal from "../../modals/projects/EditInvoiceModal";
import DeleteInvoiceModal from "../../modals/projects/DeleteInvoiceModal";

const InvoiceSection = () => {
  const [open, setOpen] = useState(true);
  const [selected, setSelected] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [invoices, setInvoices] = useState([
    {
      id: "#INV-123",
      title: "Phase 2 Completion",
      date: "11 Sep 2025, 05:35 pm",
      amount: "$6,598",
      status: "Paid",
    },
    {
      id: "#INV-124",
      title: "Advance for Project",
      date: "14 Sep 2025, 05:35 pm",
      amount: "$3312",
      status: "Hold",
    },
    {
      id: "#INV-125",
      title: "Changes & design Alignments",
      date: "15 Sep 2025, 05:35 pm",
      amount: "$4154",
      status: "Paid",
    },
    {
      id: "#INV-127",
      title: "Phase 1 Completion",
      date: "17 Sep 2025, 05:35 pm",
      amount: "$1259",
      status: "Unpaid",
    },
  ]);

  return (
    <>
      <Card className="custom-card mt-3">
        <Card.Body>

          {/* HEADER */}
          <div className="invoice-header">
            <h6>Invoices</h6>

            <FiChevronDown
              className={`accordion-icon ${open ? "rotate" : ""}`}
              onClick={() => setOpen(!open)}
            />
          </div>

          {/* CONTENT */}
          <Collapse in={open}>
            <div>

              {invoices.map((inv, i) => (
                <div key={i} className="invoice-row">

                  {/* LEFT */}
                  <div className="invoice-left">
                    <div className="invoice-icon">📄</div>

                    <div>
                      <h6 className="invoice-title">{inv.title}</h6>
                      <p className="invoice-id">
                        {inv.id} {inv.date}
                      </p>
                    </div>
                  </div>

                  {/* CENTER */}
                  <div className="invoice-amount">
                    <span>Amount</span>
                    <p>{inv.amount}</p>
                  </div>

                  {/* RIGHT */}
                  <div className="invoice-right">

                    <span className={`status ${inv.status.toLowerCase()}`}>
                      {inv.status}
                    </span>

                    <FiEdit
                      onClick={() => {
                        setSelected(inv);
                        setShowEdit(true);
                      }}
                    />

                    <FiTrash2
                      onClick={() => {
                        setSelected(inv);
                        setShowDelete(true);
                      }}
                    />
                  </div>
                </div>
              ))}

            </div>
          </Collapse>

        </Card.Body>
        <style>
          {
            `
            .custom-card{
            border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
            }
            .invoice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.invoice-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 12px;
  margin-top: 10px;
  background: #fff;
}

/* LEFT */
.invoice-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.invoice-icon {
  font-size: 22px;
}

.invoice-title {
  font-size: 14px;
  margin: 0;
}

.invoice-id {
  font-size: 12px;
  color: #6b7280;
}

/* CENTER */
.invoice-amount span {
  font-size: 12px;
  color: #6b7280;
}

.invoice-amount p {
  font-weight: 600;
  margin: 0;
}

/* RIGHT */
.invoice-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* STATUS */
.status {
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 12px;
}

.status.paid {
  background: #dcfce7;
  color: #16a34a;
}

.status.hold {
  background: #fef9c3;
  color: #ca8a04;
}

.status.unpaid {
  background: #fee2e2;
  color: #dc2626;
}

/* ICONS */
.invoice-right svg {
  cursor: pointer;
  color: #6b7280;
}

/* ACCORDION */
.accordion-icon {
  cursor: pointer;
  transition: 0.3s;
}

.rotate {
  transform: rotate(180deg);
}

/* MOBILE */
@media (max-width: 768px) {
  .invoice-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .invoice-right {
    width: 100%;
    justify-content: space-between;
  }
}`
          }
        </style>
      </Card>

      {/* MODALS */}
      <EditInvoiceModal
        show={showEdit}
        data={selected}
        handleClose={() => setShowEdit(false)}
      />

      <DeleteInvoiceModal
        show={showDelete}
        handleClose={() => setShowDelete(false)}
        onDelete={() =>
          setInvoices(invoices.filter(i => i.id !== selected.id))
        }
      />
    </>
  );
};

export default InvoiceSection;